export class ScreenColApiModel {
  id: string;

  coordinate: number;
}
